export enum OrgType {
  System = 'SYSTEM',
  Operator = 'OPERATOR',
}

export enum AuthType {
  Platform = 'PLATFORM',
  Sso = 'SSO',
}

export enum TenantMarketRegion {
  Uk = 'UK',
  Aus = 'AUS',
}

export enum TenantSettingsKey {
  WebappDashboardEnabled = 'WEBAPP_DASHBOARD_ENABLED',
  WebappGlobalVehiclesEnabled = 'WEBAPP_GLOBAL_VEHICLES_ENABLED',
  WebappGlobalChargersEnabled = 'WEBAPP_GLOBAL_CHARGERS_ENABLED',
  WebappDashboardVehicleStateOfChargeSummaryEnabled = 'WEBAPP_DASHBOARD_VEHICLE_STATE_OF_CHARGE_SUMMARY_ENABLED',
  WebappSharingEnabled = 'WEBAPP_SHARING_ENABLED',
  WebappRoamingEnabled = 'WEBAPP_ROAMING_ENABLED',
  WebappFlexibilityEnabled = 'WEBAPP_FLEXIBILITY_ENABLED',
  WebappAiAssistantEnabled = 'WEBAPP_AI_ASSISTANT_ENABLED',
  WebappPredictiveAnalyticsEnabled = 'WEBAPP_PREDICTIVE_ANALYTICS_ENABLED',
  WebappDisplayTimezonesEnabled = 'WEBAPP_DISPLAY_TIMEZONES_ENABLED',
}
